import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { GetInternshipLocationUseCaseInterface } from 'domain/usecases';

interface InternshipLocation {
  data: GetInternshipLocationUseCaseInterface.Result;
}

interface IPayloadData
  extends PayloadAction<GetInternshipLocationUseCaseInterface.Result> {}

const initialState: InternshipLocation = {
  data: null,
};

export const InternshipLocationSlice = createSlice({
  name: 'internship-location',
  initialState,
  reducers: {
    loadInternshipLocation: (state, action: IPayloadData) => {
      state.data = action.payload;
    },
    cleanInternshipLocation: (state) => {
      state.data = null;
    },
  },
});

export const { loadInternshipLocation, cleanInternshipLocation } =
  InternshipLocationSlice.actions;

export default InternshipLocationSlice.reducer;
